__turbopack_context__.v({
  "advertorialBadge": "_99I8Za_advertorialBadge",
  "blogTeaserBanner": "_99I8Za_blogTeaserBanner",
  "blogTeaserBox": "_99I8Za_blogTeaserBox",
  "blogTeaserText": "_99I8Za_blogTeaserText",
  "blogTeaserTitle": "_99I8Za_blogTeaserTitle",
  "boxTeaserWrapper": "_99I8Za_boxTeaserWrapper",
  "category": "_99I8Za_category",
});
